import { create } from 'zustand';
import { detectEnglishVariant, LOCALES, getSpelling, localizeText } from '../utils/localization';

const initialState = {
  locale: typeof window !== 'undefined' 
    ? localStorage.getItem('preferred-locale') || detectEnglishVariant()
    : LOCALES.BRITISH,
};

console.log('localization initial state: ', initialState);

export const useLocalizationStore = create((set, get) => ({
  ...initialState,
  
  setLocale: (locale) => {
    set({ locale });
    if (typeof window !== 'undefined') {
      localStorage.setItem('preferred-locale', locale);
    }
  },
  
  // Helper methods
  spell: (word) => getSpelling(word, get().locale),
  localize: (text) => localizeText(text, get().locale),
  t: (strings, ...values) => {
    const text = strings.reduce((result, string, i) => {
      return result + string + (values[i] || '');
    }, '');
    return localizeText(text, get().locale);
  },

  resetLocalization: () => set(initialState),
}));

// Selector hooks
export const useLocale = () => useLocalizationStore(state => state.locale);
export const useIsAmerican = () => useLocalizationStore(state => state.locale === LOCALES.AMERICAN);
export const useIsBritish = () => useLocalizationStore(state => state.locale === LOCALES.BRITISH);

// Action hooks
export const useSetLocale = () => useLocalizationStore(state => state.setLocale);
export const useToggleLocale = () => useLocalizationStore(state => state.toggleLocale);

// Utility hooks
export const useSpell = () => useLocalizationStore(state => state.spell);
export const useLocalize = () => useLocalizationStore(state => state.localize);
export const useT = () => useLocalizationStore(state => state.t);

export const useResetLocalization = () => useLocalizationStore(state => state.resetLocalization);
